import { render, staticRenderFns } from "./ExpandingInformation.vue?vue&type=template&id=39b5b4f7"
import script from "./ExpandingInformation.vue?vue&type=script&lang=js"
export * from "./ExpandingInformation.vue?vue&type=script&lang=js"
import style0 from "./ExpandingInformation.vue?vue&type=style&index=0&id=39b5b4f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports